const locks = new WeakMap<HTMLElement, { count: number; overflow: string }>();

/** Keep overlapping dialogs locked even when they close out of mount order. */
export function lockDialogScroll(body: HTMLElement = document.body): () => void {
  const lock = locks.get(body) ?? { count: 0, overflow: body.style.overflow };
  lock.count += 1;
  locks.set(body, lock);
  body.style.overflow = 'hidden';
  let released = false;
  return () => {
    if (released) return;
    released = true;
    lock.count -= 1;
    if (!lock.count) {
      body.style.overflow = lock.overflow;
      locks.delete(body);
    }
  };
}
